export class UpdatePlayersBetsRequest {
    static Message = 'UpdatePlayersBetsRequest';

    public gameId: string;
    public playerBetToAdd: string;
    public socketId: string;

    constructor(gameId: string, playerBetToAdd: string, socketId: string) {
        this.gameId = gameId;
        this.socketId = socketId;
        this.playerBetToAdd = playerBetToAdd;
    }
}

export class UpdatePlayersBetsResponse {
    static Message = 'UpdatePlayersBetsResponse';

    public playerBetToAdd: string;
    public socketId: string;

    constructor(playerBetToAdd: string, socketId: string) {
        this.socketId = socketId;
        this.playerBetToAdd = playerBetToAdd;
    }
}
